import { Dimensions } from 'react-native'
import { Appearance } from 'react-native-web'
import { useColorScheme } from '../../../contexts/ColorSchemeContext'
import { coalesce } from '../../utils/utils'

export const getDeafultTheme = (lightMode: boolean): any => ({
  colorScheme: lightMode ? 'light' : 'dark',
  bgGradientColor1: '#333447',
  bgGradientColor2: '#3D3F50',
  buttonBgColor: '#656686',
  disabledButtonBgColor: '#88888888',
  buttonTextColor: '#ffffff',
  whiteTextColor: '#ffffff',
  validPasswordTextGreen: lightMode ? '#4FA0E6' : '#76BFFE',
  errorRed: '#FF6E5D',
  tabletSignUpMaxWidth: 500,
  mainText: '#D8D8D8',
  secondaryDarkColor: '#242532',
  activeTabBGColor: '#62627a',
  activeTabBorderColor: '#979797',
  yellowActiveHighlight: '#FDC72A',
  inactiveHexagonColor: '#D8D8D8',
  lockedHexagonColor: 'rgba(190, 192, 208, 0.7)',
  activeBlueColor: '#76BFFE',
  darkerActiveBlueColor: 'rgba(79, 160, 230, 1)',
  tealColor: '#76feea',
  activeBlueWithOpacity: 'rgba(118, 191, 254, 0.15)',
  hexagonStrokeWidth: 3,
  disabledOverlayColor: '#656686',
  unauthenticatedButtonHeight: 50,
  playerBackgroundColor: '#020101',
  inactiveGrayPlayerColor: '#979797',
  questionMultiOptionInactiveBorderColor: '#737373',
  activeSubmitButtonShadowColor: '#10A5FC',
  profileOptionBorderColor: '#666770',
  pickerSelectedBackgroundColor: 'rgba(190, 192, 208, 0.18)',
  transparentBlack: 'rgba(0, 0, 0, 0.2)',
  blackColor: '#000000',
  lessonPlayerFadeSpeed: 400,
  grayBorder: '#D8D8D8',
  unfilledGrayBorder: 'rgb(99,99,99)',
  grayTransparentBorder: 'rgba(216,216,216,0.35)',
  pointsEarnedColor: '#FDC72A',
  courseProgressColor: '#74BBF9',
  teacherInterfaceStatusBarColor: 'black',
  buttonDisabledColor: 'rgba(255,255,255,0.19)',
  lightActiveBlueColor: '#C1E0FB',
  lighterError: '#F98686',
  slightlyDarkerError: '#FF5656',
  darkerError: '#CA2626',
  questionMultiWithImageCardBackgroundColor: '#333334',
  tabletOuterPadding: 64,
  mobileOuterPadding: 16,
  player: {
    incorrectAnswerChoice: '#EE5555',
    incorrectFeedbackModalContinueButtonShadow: '#CB3E3E',
    incorrectFeedbackModalBackground: '#202121',
    correctFeedbackModalTextColor: '#000000',
    textColor: '#ffffff',
  },
  dashboardV2: {
    header: {
      backgroundColor: lightMode ? '#FFFFFF' : '#232538',
      bottomBorderColor: lightMode ? '#DBDBDB' : '#3D3D3D',
      fontColor: lightMode ? '#000000' : '#FFFFFF',
      libraryIconColor: lightMode ? '#76BFFE' : '#76BFFE',
      buttonLabelColor: lightMode ? '#FBFBFB' : '#2C2E41',
      buttonLabelTextColor: lightMode ? '#000' : '#FFF',
      buttonLabelBorderStyles: {
        borderWidth: lightMode ? 0 : 1,
        borderStyle: 'solid',
        borderColor: '#333448',

      },
      buttonLabelShadowStyles: {
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowRadius: lightMode ? 1 : 0,
        shadowOpacity: lightMode ? 0.15 : 0,
        elevation: lightMode ? 1 : 0,
        shadowColor: '#000',
      },

      progressIllustrationColor: lightMode ? '#636363' : '#D8D8D8',
    },
    content: {
      fontColor: lightMode ? '#000000' : '#FFFFFF',
      nextUpLabelColor: '#000000',
      backgroundColor: lightMode ? '#FAFAFA' : '#191A28',
      tileBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
      itemDetailBorderColor: lightMode ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.39)',
      itemDescriptionTextColor: lightMode ? 'rgba(0,0,0,0.65)' : 'rgba(255,255,255,0.85)',
    },
    button: {
      buttonBackgroundColor: '#76BFFE',
      buttonBottomBorderColor: '#10A5FC',
      textColor: lightMode ? '#FFFFFF' : '#000000',
    },
    progressBar: {
      unfilledBackgroundColor: '#D8D8D8',
      filledColor: '#76BFFE',
    },
  },
  bottomTabs: {
    backgroundColor: lightMode ? '#FFFFFF' : '#232538',
    iconColor: lightMode ? '#3A3938' : '#FFFFFF',
    borderTopColor: lightMode ? '#DBDBDB' : '#3D3D3D',
  },
  leftTabs: {
    backgroundColor: '#232538',
  },
  tileShadowStyle: {
    boxShadow: lightMode ? '0px 1px 3px 0px rgba(165, 165, 165, 0.75)' : '0px 2px 4px 1px rgba(0, 0, 0, 0.50)',
  },
  tileBorderColor: lightMode ? '#D8D8D8' : '#575861',
  backgroundColor: lightMode ? '#FAFAFA' : '#191A28',
  tabTitleColor: lightMode ? '#000000' : '#FFFFFF',
  logoTextColor: lightMode ? '#000000' : '#FFFFFF',
  videoLibrary: {
    headerBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    headerBottomBorderColor: lightMode ? '#DBDBDB' : '#3D3D3D',
    mainContentBackgroundColor: lightMode ? '#FAFAFA' : '#191A28',
    cardBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    playlistCountBackgroundColor: '#76BFFE',
    cardFontColor: lightMode ? '#000000' : '#FFFFFF',
    headerFontColor: lightMode ? '#000000' : '#FFFFFF',
    drilldownLockIconColor: lightMode ? '#000000' : '#FFFFFF',
    drilldownLessonDescriptionText: lightMode ? '#000000' : '#FFFFFF',
  },
  modalHeader: {
    iconColor: lightMode ? '#000000' : '#FFFFFF',
    titleColor: lightMode ? '#000000' : '#FFFFFF',
  },
  profile: {
    profileOptionSeparatorColor: lightMode ? '#666770' : '#666770',
    profileOptionContentColor: lightMode ? '#000000' : '#FFFFFF',
  },
  textInput: {
    backgroundColor: lightMode ? '#F3F3F3' : '#353642',
    textColor: lightMode ? '#000000' : '#FFFFFF',
    labelColor: lightMode ? '#636363' : '#FFFFFF',
    outlineColor: lightMode ? '#E1E1E1' : '#9E9E9E',
  },
  fourDigitValidationInput: {
    backgroundColor: lightMode ? '#F3F3F3' : '#353642',
    disabledBackgroundColor: lightMode ? '#6088a4' : '#6088a4',
    textColor: lightMode ? '#000000' : '#FFFFFF',
    borderColor: lightMode ? '#A0A0A0' : '#9E9E9E',
    focusedBorderColor: lightMode ? '#000000' : '#FFFFFF',
    hasValueBorderColor: lightMode ? '#76BFFE' : '#76BFFE',
  },
  button: {
    loaderDotsActive: lightMode ? '#FFFFFF' : '#FFFFFF',
    loaderDotsInactive: lightMode ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.5)',
  },
  opaqueButton: {
    backgroundColor: lightMode ? '#76BFFE' : '#76BFFE',
    disabledBackgroundColor: lightMode ? '#979797' : '#979797',
  },
  transparentButton: {
    backgroundColor: lightMode ? '#FFFFFF' : '#000000',
    labelFontColor: lightMode ? '#000000' : '#FFFFFF',
    borderColor: lightMode ? '#000000' : '#FFFFFF',
  },
  passwordValidator: {
    invalidTextColor: lightMode ? '#000000' : '#FFFFFF',
  },
  deleteAccount: {
    areYouSureBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    fontColor: lightMode ? '#000000' : '#FFFFFF',
    borderColor: lightMode ? '#000000' : '#353648',
  },
  linkButton: {
    textColor: lightMode ? '#000000' : '#FFFFFF',
  },
  v2General: {
    fontColor: lightMode ? '#000000' : '#FFFFFF',
    tileBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
  },
  loginSignup: {
    modalBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    modalBorderColor: lightMode ? '#000000' : '#353648',
    fontColor: lightMode ? '#000000' : '#FFFFFF',
  },
  dialog: {
    backgroundColor: lightMode ? '#FFFFFF' : '#232538',
    borderColor: lightMode ? '#000000' : '#353648',
  },
  carouselDots: {
    active: lightMode ? '#525252' : '#FFFFFF',
    inactive: lightMode ? '#BCBCBC' : '#5B5B5B',
  },
  completionPage: {
    reflectionQuestionFontColor: lightMode ? '#111' : '#fff',
    reflectionAnswerFontColor: lightMode ? '#222' : '#CFCFD3',
    personalBestPrevBackgroundColor: lightMode ? '#EEEEEE' : '#2C2E41',
    personalBestPrevBorderColor: lightMode ? '#666666' : '#575861',
    personalBestPrevFontColor: lightMode ? '#666666' : '#CFCFD3',
    personalBestNewBackgroundColor: lightMode ? '#F1F7FB' : '#001F36',
    personalBestNewBorderColor: lightMode ? '#4FA0E6' : '#76BFFE',
    personalBestNewFontColor: lightMode ? '#76BFFE' : '#76BFFE',
    milestoneProgressBackgroundColor: lightMode ? '#E5E5E5' : '#575861',
    cardBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    cardBorderColor: lightMode ? '#d8d8d8' : '#575861',
    streakMessageFontColor: lightMode ? '#666' : '#CFCFD3',
    streakInactiveBackgroundColor: lightMode ? '#E5E5E5' : '#575861',
    streakInactiveLabelColor: lightMode ? '#ABABAB' : '#CFCFD3',
    streakAvailableFlameBorderColor: lightMode ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.25)',
    streakCompleteColor: '#FF6A00',
    statLabelFontColor: lightMode ? '#666' : '#CFCFD3',
    statValueFontColor: '#76BFFE',
    backgroundColor: lightMode ? '#FAFAFA' : '#191A28',
    fontColor: lightMode ? '#000000' : '#FFFFFF',
    statisticsBorderColor: lightMode ? 'rgba(0, 0, 0, .5)' : 'rgba(255, 255, 255, .5)',
    explainerFontColor: '#000000',
  },
  optionsMenu: {
    optionDivider: lightMode ? 'rgba(0, 0, 0, .15)' : 'rgba(255, 255, 255, .15)',
    optionHoverColor: lightMode ? 'rgba(118, 191, 254, 0.15)' : 'rgba(118, 191, 254, 0.15)',
  },
  focusSeshCompletionPage: {
    headerBottomBorder: lightMode ? 'rgba(0, 0, 0, .15)' : 'rgba(255, 255, 255, .15)',
    chartAxisColor: lightMode ? '#7F7F7F' : '#797988',
    axisLabelColor: lightMode ? '#000000' : '#FFFFFF',
    chartGridColor: lightMode ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)',
    closeButtonTextColor: lightMode ? '#fff' : '#000',
  },
  focusSeshPlayer: {
    countdownCircleOutline: '#39393d',
    checkInValueOption: '#5f5f6b',
    leaveSyncedSeshButtonColor: 'rgba(100, 100, 100, 1)',
    resumeSyncedSeshButtonColor: '#ffffff',
    finishSeshButtonFontColor: '#000000',
  },
  focusSeshSetup: {
    saveAsPresetColor: '#76BFFE',
    customOptionsInputBoxBorderColor: lightMode ? 'rgba(0, 0, 0, .55)' : 'rgba(255, 255, 255, .75)',
    stickyHeaderBackgroundColor: lightMode ? 'rgba(250,250,250,0.7)' : 'rgba(25,26,40, 0.7)',
    timedVsUntimedSelectorBackgroundColor: lightMode ? '#EFEFEF' : '#2C2E41',
    timedVsUntimedActiveSegmentBackgroundColor: lightMode ? '#FFF' : '#575861',
  },
  joinSyncedSesh: {
    inactiveTileBackgroundColor: lightMode ? '#EFEFEF' : '#3C3D47',
    inactiveTileTextColor: lightMode ? '#787878' : '#9E9EA3',
  },
  focusSeshStats: {
    dateRangeSelectorBackgroundColor: lightMode ? '#EFEFEF' : '#2C2E41',
    timedVsUntimedActiveSegmentBackgroundColor: lightMode ? '#FFF' : '#575861',
    chartAccentColor: '#119DA2',
    chartPointerStripColor: lightMode ? '#E5E5E5' : '#575861',
    chartScrollIndicator: lightMode ? 'black' : 'white', // can only be white, black, or grey
    tooltipBackgroundColor: lightMode ? '#fff' : '#575861',
  },
  focusSeshOrientation: {
    inactiveDot: lightMode ? 'rgba(0, 0, 0, .05)' : 'rgba(255, 255, 255, .05)',
    inactiveDotDark: 'rgba(255, 255, 255, .2)',
    backgroundColor: lightMode ? '#FFF' : '#020101'
  },
  softAskReviewDialog: {
    backgroundColor: lightMode ? '#FFFFFF' : '#232538',
    borderColor: lightMode ? '#FFFFFF' : '#232538',
    exitIconColor: lightMode ? '#000000' : '#FFFFFF',
    initialAskButtonBackgroundColor: lightMode ? '#F9F9F9' : '#232538',
    initialAskButtonBorderColor: lightMode ? '#C6C6C6' : '#4F5160',
    textColor: lightMode ? '#000000' : '#FFFFFF',
    textAreaBackgroundColor: '#FFFFFF',
  },
  focusSeshDashboard: {
    headerImageTint: lightMode ? '#1e80d5' : '#76BFFE',
    pageBodyBackgroundColor: lightMode ? '#FAFAFA' : '#191A28',
    previewCardBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    previewCardDividingLine: {
      borderTopColor: lightMode ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.15)',
      borderTopWidth: 1,
    },
    lightGreyBackgroundColor: lightMode ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.05)',
    darkGreyBackgroundColor: lightMode ? 'rgba(0,0,0,0.35)' : 'rgba(255,255,255,0.55)',
    setUpNewSeshBorder: {
      borderWidth: lightMode ? 1 : 1,
      borderRadius: 12,
      borderColor: lightMode ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.2)',
    },
    headerBackgroundColor: lightMode ? '#FFFFFF' : '#232538',
    statsCarouselFadeOverlayColors: lightMode ? ['rgba(255,255,255,1)', 'rgba(255,255,255,0)', 'rgba(255,255,255,0)', 'rgba(255,255,255,1)'] : ['rgba(35,37,56,1)', 'rgba(35,37,56,0)', 'rgba(35,37,56,0)', 'rgba(35,37,56,1)'],
    drilldownArrowImageTint: lightMode ? '#000' : '#FFF',
    presetsScrollBarColor: lightMode ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)'
  },
  soundtrackDialog: {
    headerBackgroundColor: lightMode ? 'rgba(255,255,255,0.7)' : 'rgba(35, 37, 56, 0.7)',
    scrollButtonBackgroundColor: lightMode ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.8)',
    scrollButtonIconColor: lightMode ? '#FFF' : '#000',
    gradientStartColor: lightMode ? 'rgba(255,255,255,0)' : 'rgba(25, 26, 40, 0)',
    gradientEndColor: lightMode ? 'rgba(255,255,255,0.7)' : 'rgba(25, 26, 40, 0.7)',
  },
  focusSeshPresets: {
    deletePresetButtonBackgroundColor: '#EF0A0A',
  },
  personalReflection: {
    inactiveValueColor: lightMode ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.5)',
    buttonSectionShadow: lightMode ? '0px 0px 25px rgba(0, 0, 0, 0.1)' : '0px 0px 25px rgba(0, 0, 0, 0.50)',
  },
  postSeshFeedback: {
    pageTitleColor: lightMode ? '#374151' : '#D1D5DB',
    buttonActiveBorderColor: '#76BFFE',
    buttonInactiveBorderColor: lightMode ? '#737373' : '#303143',
  },
  slider: {
    selectedAreaBackgroundColor: '#76BFFE',
    unselectedAreaBackgroundColor: lightMode ? '#D8D8D8' : '#575861',
    thumbBorderColor: '#76BFFE',
    thumbBackgroundColor: lightMode ? '#fff' : '#232538',
  },
  blueLinkButtonColor: '#76BFFE',
  logInDividerColor: lightMode ? 'rgba(0, 0, 0, 0.25)' : 'rgba(255, 255, 255, 0.25)',
})

export const assetAspectRatios = {
  'light-blue-checkmark': 38 / 28,
  lock: 82 / 106,
  'play-button': 56 / 64,
  'play-button-gray': 116 / 140,
  'video-player': 1920 / 1080,
  'arrow-ios-right': 12 / 22,
  'arrow-ios-left': 12 / 22,
  'down-arrow': 22 / 14,
  'caught-up-check': 152 / 126,
  'finding-focus-logo-text': 1104 / 456,
  'static-brain': 560 / 476,
  'playlist-icon': 57 / 33,
  'video-library-highlight-preview': 960 / 540,
  'gray-lock': 195 / 234,
  'educator.png': 147 / 168,
  'personal.png': 147 / 132,
  'student.png': 147 / 168,
  'college.png': 135 / 168,
  'district-county.png': 143 / 143,
  'high-school.png': 120 / 168,
  'k8.png': 128 / 168,
  'honeycomb-texture.png': 294 / 104,
  'orientation-slide-1.png': 327 / 669,
  'orientation-slide-2.png': 627 / 441,
  'orientation-slide-3.png': 774 / 558,
  'orientation-slide-4.png': 249 / 1182,
  'orientation-slide-5.png': 693 / 528,
  'orientation-slide-6.png': 444 / 774,
}

export const extraSmallBreakpoint = 400
export const smallBreakpoint = 500
export const mediumBreakpoint = 840
export const largeBreakpoint = 1100

export const valuesAtBreakpoints = (
    xs: string | number,
    s: string | number,
    m: string | number,
    l: string | number | null = null,
    xl: string | number | null = null
) => {
  const { width } = Dimensions.get('window')
  if (width < extraSmallBreakpoint) return xs
  else if (width < smallBreakpoint) return s
  else if (width < mediumBreakpoint) return m
  else if (width < largeBreakpoint) return coalesce(l, m)
  else return coalesce(xl, l, m)
}

export const useTheme = ((lightModeOnly = false) => {
  const colorScheme = useColorScheme()
  return getDeafultTheme(lightModeOnly || colorScheme === 'light' || colorScheme === null)
})
export default getDeafultTheme(Appearance.getColorScheme() === 'light' || Appearance.getColorScheme() === null)
